import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import { subscriptions, SubscriptionTypeEnum } from "@store/subscriptions/subscriptions.model";
import { subscriptionsQuery } from "@store/subscriptions";

import { Colors } from "@constants/colors.constant";

import ModalComponent from "@components/modal/Modal.component";
import AIOButtonComponent from "@components/Button.component";
import SeeSubscriptionsModal from "@components/subscriptions/modal/SeeSubscriptions.modal";

interface NoCreditsModalProps {
  credits: number;
  handleClose: () => void;
}

const NoCreditsModal = (props: NoCreditsModalProps) => {
  const { credits, handleClose } = props;

  const { t } = useTranslation();

  const [openSeeSubscriptionsModal, setOpenSeeSubscriptionsModal] = useState(false);

  return (
    <>
      <ModalComponent
        handleClose={handleClose}
        title={t("subscriptions.noMoreFeatureCreditsTitle")}
        content={
          <Stack py="10px">
            <Typography textAlign="center" style={{ wordBreak: "break-word" }} color={Colors.secondaryText} lineHeight="1.25" mt="6px">
              {t("subscriptions.noMoreFeatureCredits", {
                count: credits,
                date: subscriptionsQuery.nextCreditsRenewDate,
              })}
            </Typography>
          </Stack>
        }
        actions={
          <AIOButtonComponent
            title={t("subscriptions.seeSubscriptions")}
            variant="contained"
            ariaLabel="modal"
            onClick={() => setOpenSeeSubscriptionsModal(true)}
          />
        }
        maxWidth="xs"
      />
      {openSeeSubscriptionsModal && (
        <SeeSubscriptionsModal
          subscriptions={subscriptions.filter(
            (s) =>
              s.type === SubscriptionTypeEnum.COMPANY || (!subscriptionsQuery.sessionUserSubscriptionOngoing && s.type === SubscriptionTypeEnum.PROFESSIONAL)
          )}
          handleClose={() => setOpenSeeSubscriptionsModal(false)}
        />
      )}
    </>
  );
};

export default NoCreditsModal;
